import React from 'react'
import { SvgIconProps } from '@mui/material'
import { nothing } from '$func/utils'
import { HallAvatar } from '$common/avatar'
import { ChannelIcon, GroupIcon } from '$common/icons'
import { useRoom } from '$logic/room/react-hook'
import { useHall } from '$logic/hall/react-hook'
import { WithQueryHallListItemTitle } from './with-query-hall-list-item-title'
import { WithQueryHallListItemStatus } from './with-query-hall-list-item-status'
import { ChatListItem } from '../chat-list-item'
import { AvatarSize } from '$common/avatar/avatar-base/types'

interface Props {
  roomId: string
  SecondaryActionIcon?: React.ComponentType<SvgIconProps>
  hasDivider?: boolean
  onSecondaryActionIconClick?: () => unknown
  onClick: () => unknown
  onContextMenu?: (e: Event) => unknown
  selected?: boolean
  searchQuery: string
}

export function SearchedHallListItemWithStatus({
  roomId,
  SecondaryActionIcon,
  hasDivider = true,
  onSecondaryActionIconClick = nothing,
  onClick,
  onContextMenu = nothing,
  selected = false,
  searchQuery,
}: Props) {
  const room = useRoom(roomId)
  const { entity: hall } = useHall(roomId)
  const primaryTextIcon =
    room?.type === 'CHANNEL' ? (
      <ChannelIcon
        sx={{ color: 'primary.main', width: '20px', height: '20px' }}
      />
    ) : room?.type === 'GROUP' ? (
      <GroupIcon
        sx={{ color: 'primary.main', width: '20px', height: '20px' }}
      />
    ) : undefined

  return (
    <ChatListItem
      avatarComponent={
        <HallAvatar
          roomId={roomId}
          selected={selected}
          size={AvatarSize.MD}
          workspaceId={room?.workspaceId}
          withStory
        />
      }
      primaryTextIcon={primaryTextIcon}
      primaryText={
        <WithQueryHallListItemTitle hallId={roomId} query={searchQuery} />
      }
      secondaryText={
        <WithQueryHallListItemStatus
          color="neutral500"
          hallId={roomId}
          query={searchQuery}
        />
      }
      verified={hall?.verified}
      SecondaryActionIcon={SecondaryActionIcon}
      hasDivider={hasDivider}
      onClick={onClick}
      onContextMenu={onContextMenu}
      onSecondaryActionIconClick={onSecondaryActionIconClick}
    />
  )
}
